__turbopack_context__.v({
  "cardCitation": "RXcGQq_cardCitation",
  "cardDescription": "RXcGQq_cardDescription",
  "cardTitle": "RXcGQq_cardTitle",
  "gradientLeft": "RXcGQq_gradientLeft",
  "gradientRight": "RXcGQq_gradientRight",
  "header": "RXcGQq_header",
  "label": "RXcGQq_label",
  "logosLabel": "RXcGQq_logosLabel",
  "logosList": "RXcGQq_logosList",
  "marquee": "RXcGQq_marquee",
  "marqueeContent": "RXcGQq_marqueeContent",
  "marqueeWrapper": "RXcGQq_marqueeWrapper",
  "moreCount": "RXcGQq_moreCount",
  "moreSection": "RXcGQq_moreSection",
  "moreText": "RXcGQq_moreText",
  "principleCard": "RXcGQq_principleCard",
  "researchLogo": "RXcGQq_researchLogo",
  "researchLogos": "RXcGQq_researchLogos",
  "scroll": "RXcGQq_scroll",
  "section": "RXcGQq_section",
  "subtitle": "RXcGQq_subtitle",
  "title": "RXcGQq_title",
});
